import {Component, OnInit} from '@angular/core';

import {login} from '@ekultur/authentication';
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-logout-page',
  imports: [],
  templateUrl: './logout-page.html',
  styleUrl: './logout-page.scss',
})
export class LogoutPage implements OnInit {
  ngOnInit() {
    login({
      locationPostLogin: null,
      redirectUri: null,
      loginHost: environment.ekulturLoginGatewayURL
    });
  }
}
